import { useEffect, useMemo } from "react";
import { matchPath, useLocation, useParams } from "react-router";
import { useGetEtudeQuery } from "store/api";
import { setAcoustiqueSolution, setEtudeData, setEtudeId, setSolutions, setNoSolution } from "store/etudeSlice";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { InstallationType, useGetSolutionsQuery } from "./useGetSolutionsQuery";
import { APP_URL } from "utils/defines";
import { boilerTypeArrayToApiNumber } from "utils/helpers/boilerType";
import { patchMissingLocation } from "utils/stationMapping";

export const useSetCurrentEtudeData = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const { etudeId: etudeParam } = useParams();
  const { network } = useSalesNetwork();
  const { getHybrideSolutions, getElectricSolutions } = useGetSolutionsQuery();
  const { etudeData, etudeId } = useAppSelector((state) => state.etude);

  const { installationType, solutionRequestBody } = useMemo(() => {
    const json = etudeData?.json ? JSON.parse(etudeData?.json) : null;
    if (json) patchMissingLocation(json);
    const { installationType, solutionRequestBody } = json || {};

    return { installationType, solutionRequestBody };
  }, [etudeData]);

  //  const { installationType, solutionRequestBody } =useMemo() json || {};
  const { data: serverEtudeData, isFetching: isEtudeFetching } =
    useGetEtudeQuery(
      {
        id: etudeId as number,
        code: network?.code,
      },
      {
        skip: !network || isNaN(Number(etudeId)) || !!etudeData || !etudeId,
      }
    );

  useEffect(() => {
    if (
      network &&
      installationType &&
      solutionRequestBody &&
      [APP_URL.Solutions, APP_URL.SolutionDetailDocuments].some((url) =>
        matchPath(
          {
            path: `${APP_URL.Base}/${APP_URL.Etude}/${url}`,
            end: false,
          },
          pathname
        )
      )
    ) {
      (async () => {
        try {
          const apiRequestBody: GetSolutionRequest = {
            ...solutionRequestBody,
            filtres: {
              ...(solutionRequestBody.filtres || {}),
              type_chaudiere: boilerTypeArrayToApiNumber(
                solutionRequestBody.filtres?.type_chaudiere
              ) as any,
            },
          };
          const result = await (installationType === InstallationType.electric
            ? getElectricSolutions
            : getHybrideSolutions)(apiRequestBody).unwrap();
          dispatch(setAcoustiqueSolution(result.acoustique_solution ?? false));
          if (!result.solutions) {
            dispatch(setNoSolution(true));
            throw new Error();
          } else {
            dispatch(setSolutions(result.solutions));
          }
        } catch {

          dispatch(setNoSolution(true));
          dispatch(setSolutions([]));
        }
      })();
    }
  }, [network, installationType, solutionRequestBody]);

  useEffect(() => {
    if (etudeParam != etudeId && etudeParam) {
      dispatch(setEtudeId(etudeParam));
    }
  }, [etudeParam]);

  useEffect(() => {
    if (etudeId && !etudeData && serverEtudeData?.id == etudeId) {
      dispatch(setEtudeData({ ...serverEtudeData, etudeId }));
    }
  }, [etudeData, etudeId, serverEtudeData]);

  return { isEtudeFetching };
};
